import { createEmptyWeek } from "@spike/model";
export var MarketplaceDepositType;
(function (MarketplaceDepositType) {
    MarketplaceDepositType["None"] = "none";
    MarketplaceDepositType["Amount"] = "amount";
    MarketplaceDepositType["Percentage"] = "percentage";
})(MarketplaceDepositType || (MarketplaceDepositType = {}));
export var IntakeFormCustomQuestionCategory;
(function (IntakeFormCustomQuestionCategory) {
    IntakeFormCustomQuestionCategory["FOR_PETS"] = "for_pets";
    IntakeFormCustomQuestionCategory["FOR_CUSTOMERS"] = "for_customers";
})(IntakeFormCustomQuestionCategory || (IntakeFormCustomQuestionCategory = {}));
export var MarketplaceScheduleType;
(function (MarketplaceScheduleType) {
    MarketplaceScheduleType["Work"] = "work_schedule";
    MarketplaceScheduleType["MultiSlots"] = "multi_slots";
})(MarketplaceScheduleType || (MarketplaceScheduleType = {}));
export var emptyMarketplace = {
    basics: {
        businessName: "",
        email: "",
        phone: "",
        website: "",
        address: {
            street: "",
            city: "",
            state: "",
            zipcode: "",
        },
    },
    additionalInfo: {
        yearsInBusiness: 0,
        numberOfEmployees: 0,
        mobileBusiness: false,
        localBusiness: false,
        atHomeBusiness: false,
        inHomeBusiness: false,
        taxRate: 0,
    },
    schedule: {
        timeZone: "",
        week: createEmptyWeek(),
        specialHours: [],
    },
    logos: {},
    requirements: {
        spayedAndNeureted: false,
        requirements: [],
        otherRequirements: [],
    },
    petTypes: {
        dogs: {
            enabled: false,
            ages: [],
            sizes: [],
            hairTypes: [],
            hairLengths: [],
        },
        cats: {
            enabled: false,
            ages: [],
            sizes: [],
            hairTypes: [],
            hairLengths: [],
        },
        exotics: {
            enabled: false,
            types: [],
            others: [],
            sizes: [],
        },
    },
    taxes: [{ id: 0, uuid: "test-1", name: "My tax", percentage: 15 }],
    tips: [{ id: 0, uuid: "test-1", percentage: 5 }, { id: 1, uuid: "test-2", percentage: 18 }, { id: 2, uuid: "test-3", percentage: 25 }],
    deposit: { type: MarketplaceDepositType.None },
    staffTraining: {
        trainings: [],
        otherTrainings: [],
    },
    grooming: {
        holdingAreas: [],
        security: [],
        sizeSeparation: [],
        visibility: [],
        others: [],
    },
    marketingInfo: {
        locationsCount: 0,
    },
    legacy: {
        petTypes: [],
    },
    businessAreas: [{ id: "grooming", name: "Grooming" }],
    isDental: false,
    isGrooming: false,
    notifications: {
        newBookings: true,
        appointmentCancellations: false,
        client: false,
        emailContent: [],
        settings: []
    },
    integrations: {
        googleAnalyticsTrackingId: undefined,
    },
    onlineBooking: {
        active: false,
        slug: null,
        from: null,
        to: null,
        allowClientsSelectStaff: false,
        allowNewClients: false,
        bookingRequestsEnabled: false,
        pricingOption: 'starting_at'
    },
    onboardingStep: 0,
    paymentsEnabled: false,
    active: true,
    intakeForm: {
        enabled: false,
        questionsEnabled: false,
        questions: [],
    },
    scheduleType: MarketplaceScheduleType.Work,
    petPositivePersonality: [],
    petNegativePersonality: []
};
export var emptyPetTags = {
    positive: [],
    negative: [],
};
